import { IWeekDay } from "../models";

export function getWeekDays(removeKeys: number[] = []): IWeekDay[]
{
    var days: IWeekDay[] = [
        {
            key: 1,
            value: "Montag",
            value_en: "monday"
        },
        {
            key: 2,
            value: "Dienstag",
            value_en: "tuesday"
        },
        {
            key: 3,
            value: "Mittwoch",
            value_en: "wednesday"
        },
        {
            key: 4,
            value: "Donnerstag",
            value_en: "thursday"
        },
        {
            key: 5,
            value: "Freitag",
            value_en: "friday"
        },
        {
            key: 6,
            value: "Samstag",
            value_en: "saturday"
        },
        {
            key: 7,
            value: "Sonntag",
            value_en: "sunday"
        }
    ];

    if (removeKeys.length > 0)
        days.removeAt(item => removeKeys.contains(item.key));

    return days;
}